import { render, staticRenderFns } from "./CDNDoc.vue?vue&type=template&id=57762ff8&scoped=true&"
import script from "./CDNDoc.vue?vue&type=script&lang=js&"
export * from "./CDNDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57762ff8",
  null
  
)

export default component.exports